import clsx from "clsx";

export interface RadioOptionProps<T extends string = string> {
  id: string;
  name: string;
  value: T;
  checked: boolean;
  onChange: (value: T) => void;
  className?: string;
}

export default function RadioOption<T extends string = string>({
  id,
  name,
  value,
  checked,
  onChange,
  className,
}: RadioOptionProps<T>) {
  return (
    <input
      id={id}
      type="radio"
      name={name}
      value={value}
      checked={checked}
      onChange={() => onChange(value)}
      className={clsx('size-5 accent-primary-500', className)}
    />
  );
}
